import { IProps } from "./types";

{/* MSGT-4126:  Show an indicator to Recruiters when the Jobseeker is opted-in to SMS. */}
const SmsOptInInformation = (props: IProps) => {
const { onDismiss } = props

  return (
    <div style={{
      backgroundColor: '#f0f4ff',
      padding: '10px 36px 10px 10px',
      borderRadius: '6px',
      margin: '0px 10px',
      position: 'relative',
      fontSize: '14px',
      color: '#333'
    }}>
      This candidate is opted in to SMS notifications. Your messages are likely to reach them quickly.
      <button
        onClick={onDismiss}
        style={{
          position: 'absolute',
          top: '8px',
          right: '10px',
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          fontSize: '16px',
          lineHeight: '1',
          color: '#666'
        }}
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  )
}

export default SmsOptInInformation
